import { useParams, Link } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { LanguageContext } from '../components/LanguageContext';
import catalogData from '../locales/catalogData.json';
import '../styles/Catalog.css';

export default function CatalogDetail() {
    const { id } = useParams();
    const { language } = useContext(LanguageContext);
    const items = catalogData[language] || catalogData['ru'];
    const item = items.find(entry => entry.id === id);

    // 📱 Scroll to top on mobile
    useEffect(() => {
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 0, behavior: 'smooth' }); // or 'instant'
        }
    }, []);

    if (!item) {
        return <p>{language === 'kg' ? 'Товар табылган жок' : 'Товар не найден'}</p>;
    }

    const paragraphs = item.description.split('\n\n');

    return (
        <section className="catalog-detail-container">
            <div className="catalog-detail-card">
                <img
                    src={item.image}
                    alt={item.model}
                    className="catalog-detail-image"
                />
                <div className="catalog-detail-info">
                    <h2>{item.model}</h2>
                    {paragraphs.map((text, idx) => (
                        <p key={idx} className="catalog-description">
                            {text}
                        </p>
                    ))}
                    <Link to="/catalog" className="back-button">
                        {language === 'kg' ? 'Каталогго кайтуу' : 'Назад к каталогу'}
                    </Link>
                </div>
            </div>
        </section>
    );
}
